import scheduleJobIcon from '@disy/cadenza-icons/manage-subscriptions.svg';

import { Action } from 'cadenza/action';
import { isFeatureAvailable } from 'cadenza/features';
import { icon } from 'cadenza/utils/icon/icon';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';

import i18n from './manage-job-action.properties';

export class ManageJobAction extends Action {

  constructor () {
    super({ label: i18n('title'), icon: icon(scheduleJobIcon) });
  }

  override get available () {
    return isFeatureAvailable('JOB_MANAGEMENT');
  }

  override get enabledSync () {
    return true;
  }

  override executeSync () {
    this._showJobScheduleWizard();
  }

  _showJobScheduleWizard () {
    location.href = cadenzaUrl('/pages/processingChain/report/administration/index.xhtml' + location.search);
  }

}
